import React from 'react';
import { ProductTypeRowProps } from '../interfaces';

import './ProductTypeRow.scss';

const ProductTypeRow: React.FC<ProductTypeRowProps> = ({ typeName }) => (
  <div className="text-type">
    <span>Type: </span>
    <span className="type">{typeName}</span>
  </div>
);

export default ProductTypeRow;
